// ═══════════════════════════════════════════════════════════════════
//  composants/KpiCard.js
//  KpiCard
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../socle/theme";
import { Sparkline } from "./Sparkline";

export function KpiCard({ icon, label, value, color, spark, delta, deltaUp, sub }) {
  return (
    <div style={{ flex: "1 1 160px", minWidth: 160, background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 14, padding: "14px 16px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, color: THEME.textMuted, fontSize: 11, marginBottom: 8 }}>
        <span style={{ width: 28, height: 28, borderRadius: 8, background: (color || THEME.accent) + "22", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15 }}>{icon}</span>
        <span style={{ textTransform: "uppercase", fontWeight: 600 }}>{label}</span>
      </div>
      <div style={{ color: THEME.text, fontSize: 26, fontWeight: 800, lineHeight: 1.1 }}>{value}</div>
      <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginTop: 6, gap: 8 }}>
        <div style={{ fontSize: 11, color: delta == null ? THEME.textDim : deltaUp ? THEME.emerald : THEME.red, whiteSpace: "nowrap" }}>{delta == null ? (sub || "") : `${deltaUp ? "↗" : "↘"} 24h : ${deltaUp ? "+" : ""}${delta}`}</div>
        <div style={{ flex: 1, maxWidth: 130 }}>{spark && <Sparkline values={spark} color={color || THEME.accent} />}</div>
      </div>
    </div>
  );
}
